/**
 * Mobile Menu Scroll Fix - Orthocrin Theme
 * Impede scroll do body quando o menu mobile está aberto
 */
document.addEventListener('DOMContentLoaded', function() {
  // Seletor dos elementos do menu mobile
  const menuDetails = document.querySelector('.main-menu__disclosure');
  
  if (menuDetails) {
    // Observer para detectar mudanças no atributo 'open' do details
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open') {
          const isOpen = menuDetails.hasAttribute('open');
          
          // Adiciona ou remove a classe no body conforme estado do menu
          if (isOpen) {
            document.body.classList.add('mobile-menu-open');
          } else {
            document.body.classList.remove('mobile-menu-open');
          }
        }
      });
    });
    
    // Inicia observação de mudanças no atributo 'open'
    observer.observe(menuDetails, { attributes: true });
    
    // Verificação inicial do estado do menu ao carregar a página
    if (menuDetails.hasAttribute('open') && window.innerWidth < 769) {
      document.body.classList.add('mobile-menu-open');
    }
    
    // Escuta clicks no elemento para tratar o caso de fechamento pelo overlay
    document.addEventListener('click', function(e) {
      // Quando clicar fora do menu com o menu aberto, remove a classe
      if (menuDetails.hasAttribute('open') && 
          !e.target.closest('.main-menu__content') && 
          !e.target.closest('.main-menu__toggle')) {
        document.body.classList.remove('mobile-menu-open');
      }
    });
    
    // Adiciona listener para o ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menuDetails.hasAttribute('open')) {
        document.body.classList.remove('mobile-menu-open');
      }
    });
  }
  
  // Reseta o body quando a tela é redimensionada para desktop
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 769) {
      document.body.classList.remove('mobile-menu-open');
    } else if (menuDetails && menuDetails.hasAttribute('open')) {
      document.body.classList.add('mobile-menu-open');
    }
  });
});
